module.exports = __webpack_public_path__ + "static/media/majors-student-tucson.e063c4aa.png";